var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 2.58325H3.87504C3.53247 2.58325 3.20393 2.71934 2.96169 2.96157C2.71946 3.20381 2.58337 3.53235 2.58337 3.87492V27.1249C2.58337 27.4675 2.71946 27.796 2.96169 28.0383C3.20393 28.2805 3.53247 28.4166 3.87504 28.4166H27.125C27.4676 28.4166 27.7962 28.2805 28.0384 28.0383C28.2806 27.796 28.4167 27.4675 28.4167 27.1249V3.87492C28.4167 3.53235 28.2806 3.20381 28.0384 2.96157C27.7962 2.71934 27.4676 2.58325 27.125 2.58325ZM10.3334 25.8333H5.16671V5.16659H10.3334V25.8333ZM25.8334 25.8333H12.9167V16.7916H25.8334V25.8333ZM25.8334 14.2083H12.9167V5.16659H25.8334V14.2083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDashboard);
export default __webpack_public_path__ + "static/media/menu_icon_dashboard.192e85cca5a6132bd533aa95bcaae6ef.svg";
export { ForwardRef as ReactComponent };